export default function extractVideoRoot(source) {
  return source.match(/([a-z0-9]{40}\/[a-z0-9]{16})/)?.[0];
}
